import React from "react";
import Button from './Buttons';
import SemiNarrowContainer from './SemiNarrowContainer';
import guideCtaImage from "../images/guides/guide-cta.png"; 

const GuideCtaTriple = ({ ctaUrl, ctaState }) => {
    return (
        <SemiNarrowContainer className="px-4 !md:px-0">
            <div className="grid grid-cols-1 md:grid-cols-3 bg-holborn-blue text-white rounded-xl overflow-hidden">
                
                <div className="col-span-1 md:col-span-2 p-8 md:p-12 flex flex-col justify-end">
                    <p className="text-xl font-semibold mb-2">
                        Ready to speak to a specialist?
                    </p>
                    <h2 className="text-4xl lg:text-5xl font-extrabold mb-8">
                        Start your journey with Holborn Assets
                    </h2>
                    
                    <div className="flex flex-col space-y-4 lg:flex-row lg:space-y-0 lg:space-x-6">
                        <Button 
                            variant="white" 
                            to="/holborn-app/"
                            className="text-center"
                        >
                            Download the app
                        </Button>
                        <Button
                            variant="green"
                            to={ctaUrl}
                            state={ctaState}
                            className="text-center"
                        >
                            Talk to an adviser
                        </Button>
                    </div>
                </div>

                <div className="col-span-1 hidden md:block h-full w-full">
                    <img
                        src={guideCtaImage}
                        alt="Holborn Assets Adviser"
                        className="w-full h-full object-cover" 
                    />
                </div>
            </div>
        </SemiNarrowContainer>
    );
};

export default GuideCtaTriple;